import { render, staticRenderFns } from "./weaponhist.vue?vue&type=template&id=d18d8a98&scoped=true&"
import script from "./weaponhist.vue?vue&type=script&lang=js&"
export * from "./weaponhist.vue?vue&type=script&lang=js&"
import style0 from "./weaponhist.vue?vue&type=style&index=0&id=d18d8a98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18d8a98",
  null
  
)

export default component.exports